import { Card, Button, Divider, Paper, Skeleton, Typography } from '@mui/material';
import { Link, createSearchParams, useParams } from 'react-router-dom';
import { ConditionalWrapper } from '../../components/ConditionalWrapper';

export const LogUsageItem = ({sx, title, titleStatus, titleButton, children, childrenStatus, centered, centeredTitle, cardWrapper=true}) => {

    return (
        <ConditionalWrapper
            condition={cardWrapper}
            wrapper={wrapperChildren =>
                <Card sx={{p: 2, ...sx}}>
                    {wrapperChildren}
                </Card>
            }
        >
            {title &&
                titleButton ?
                    <>
                        <Button
                            component={Link}
                            sx={{ display: 'block' }}
                        >
                            {titleStatus === "loading" ? <Skeleton /> : <Typography onClick={() => { }} variant="h5" gutterBottom fontWeight="bold" align={(centered && centeredTitle) || centeredTitle ? "center" : "left"}>{title}</Typography>}
                        </Button>

                        <Divider />
                    </>
                :
                    <>
                        {titleStatus === "loading" ? <Skeleton /> : <Typography onClick={() => { }} variant="h5" gutterBottom fontWeight="bold" align={(centered && centeredTitle) || centeredTitle ? "center" : "left"}>{title}</Typography>}
                    </>
            }

            {childrenStatus === "loading" ? <><Skeleton/><Skeleton/><Skeleton/></> : children}
        </ConditionalWrapper>
    );
}